import React from "react"
import SpinnerLoader from "./spinnerLoader"
import { LayersModel } from "@tensorflow/tfjs"
import Report from "./report"
import Footer from "./footer"
import { Database } from "../typings"
import useReportData from "../hooks/useReportData"

interface Props {
  selectedTags: string[]
  model: LayersModel
  database: Database
}

const ReportLoader = ({ selectedTags, model, database }: Props) => {
  const { isLoading, reportData } = useReportData(selectedTags, model, database)

  return (
    <SpinnerLoader isLoading={isLoading}>
      {!isLoading && (
        <>
          <Report data={reportData} metrics={database.metrics} />
          <Footer />
        </>
      )}
    </SpinnerLoader>
  )
}

export default ReportLoader
